(function(){
  if(window.__svRenderIntegrity)return;
  window.__svRenderIntegrity=true;

  var queued=false;
  var observer=null;

  function mainCandidates(){
    return Array.prototype.slice.call(document.querySelectorAll('[id="MainContent"], main')).filter(function(node){
      return node && node.isConnected && !node.closest('template');
    });
  }

  function directOwner(main,selector){
    if(!main)return false;
    var node=main.querySelector(selector);
    if(!node)return false;
    return node.closest('[id="MainContent"], main')===main;
  }

  function activeMain(){
    var shellMain=document.querySelector('.page-wrapper > [id="MainContent"]');
    if(shellMain && shellMain.isConnected)return shellMain;

    var list=mainCandidates();
    if(!list.length)return null;

    var best=list[0];
    var bestScore=-1;
    list.forEach(function(main,index){
      var score=index;
      if(main.id==='MainContent')score+=20;
      if(main.parentElement && main.parentElement.classList.contains('page-wrapper'))score+=40;
      try{
        var style=getComputedStyle(main);
        if(style.display!=='none' && style.visibility!=='hidden')score+=8;
      }catch(error){}
      if(directOwner(main,'[data-sv-project-tracks]'))score+=18;
      if(directOwner(main,'[data-sv-song-page]'))score+=18;
      if(directOwner(main,'#shopify-section-section_dwK8WG'))score+=18;
      if(directOwner(main,'[data-sv8-charts-page]'))score+=18;
      if(directOwner(main,'[data-sv-creator-profile]'))score+=18;
      if(directOwner(main,'.sv-directory'))score+=6;
      if(score>=bestScore){best=main;bestScore=score;}
    });
    return best;
  }

  function removeOutside(main,selector){
    document.querySelectorAll(selector).forEach(function(node){
      if(!main || !main.contains(node))node.remove();
    });
  }

  function directMatches(main,selector){
    if(!main)return [];
    return Array.prototype.slice.call(main.querySelectorAll(selector)).filter(function(node){
      return node.closest('[id="MainContent"], main')===main;
    });
  }

  function keepLast(main,selector){
    var list=directMatches(main,selector);
    if(list.length<2)return;
    list.slice(0,-1).forEach(function(node){node.remove();});
  }

  function cleanCommon(main){
    [
      '[data-sv3]',
      '[data-sv4]',
      '[data-sv-phase2-record]',
      '.sv5-related',
      '[data-sv8-context]',
      '[data-sv8-artist-charting]',
      '[data-sv8-home-chart-link]',
      '[data-sv9]',
      '[data-sv11-song-credits]',
      '[data-sv11-project-credits]',
      '[data-sv11-artist-network]'
    ].forEach(function(selector){removeOutside(main,selector);});

    document.querySelectorAll('[data-sv-release-hero],[data-sv-artist-hero]').forEach(function(node){
      if(!main || !main.contains(node))node.remove();
    });

    keepLast(main,'[data-sv-phase2-record]');
    keepLast(main,'.sv5-related');
    keepLast(main,'[data-sv8-context]');
    keepLast(main,'[data-sv8-artist-charting]');
    keepLast(main,'[data-sv8-home-chart-link]');
    keepLast(main,'[data-sv11-song-credits]');
    keepLast(main,'[data-sv11-project-credits]');
    keepLast(main,'[data-sv11-artist-network]');
  }

  function cleanProject(main){
    if(!main)return;
    var isProject=directOwner(main,'[data-sv-project-tracks]') || directOwner(main,'.sv4[data-sv4]');
    if(!isProject)return;

    document.querySelectorAll('[data-sv-release-hero],.sv-release-hero').forEach(function(node){node.remove();});

    directMatches(main,'.sv-project-header').forEach(function(header){
      var wrapper=header.closest('.shopify-section') || header;
      wrapper.hidden=true;
      wrapper.setAttribute('data-sv4-old-header','');
    });

    keepLast(main,'.sv4[data-sv4]');
    keepLast(main,'[data-sv-project-tracks]');
  }

  function cleanArtist(main){
    if(!main)return;
    var isArtist=directOwner(main,'#shopify-section-section_dwK8WG') || directOwner(main,'.sv3p');
    if(!isArtist)return;

    document.querySelectorAll('[data-sv-artist-hero]').forEach(function(node){
      if(!main.contains(node) || main.querySelector('.sv3p'))node.remove();
    });

    keepLast(main,'.sv3p');
    keepLast(main,'.sv3n');
    keepLast(main,'#sv3-videos');
    keepLast(main,'#sv3-connections');
  }

  function cleanSong(main){
    if(!main)return;
    var isSong=directOwner(main,'[data-sv-song-page]') || directOwner(main,'[data-sv-phase2-record]');
    if(!isSong)return;
    keepLast(main,'[data-sv-phase2-record]');
    keepLast(main,'.sv5-related');
    keepLast(main,'[data-sv11-song-credits]');
  }

  function sweep(){
    var main=activeMain();
    if(!main)return;
    cleanCommon(main);
    cleanProject(main);
    cleanArtist(main);
    cleanSong(main);
  }

  function queueSweep(){
    if(queued)return;
    queued=true;
    requestAnimationFrame(function(){
      queued=false;
      sweep();
    });
  }

  function start(){
    sweep();
    queueSweep();
    if(observer)return;
    observer=new MutationObserver(queueSweep);
    observer.observe(document.body,{childList:true,subtree:true});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',start,{once:true});
  }else{
    start();
  }

  document.addEventListener('songvalley:page:loaded',function(){
    sweep();
    setTimeout(sweep,0);
    setTimeout(sweep,80);
  });

  document.addEventListener('shopify:section:load',function(){
    setTimeout(sweep,0);
    setTimeout(sweep,80);
  });

  window.addEventListener('pageshow',function(){setTimeout(sweep,0);});

  window.SongValleyRenderIntegrity={
    activeMain:activeMain,
    sweep:sweep
  };
})();
